if (!window.Maximize.loadedScript.includes('custom-variant-picker.js')) {
  window.Maximize.loadedScript.push("custom-variant-picker.js");

  class CustomVariantPicker extends HTMLElement {
    static cacheData = {};
    
    constructor() {
      super();
      this.pickerType = this.dataset.pickerType || 'swatch';
      this.productId = this.dataset.productId;
      this.sectionId = this.dataset.sectionId;
      this.productUrl = this.dataset.url;
      this.isMainProduct = this.dataset.mainProduct === 'true';
      this.optionElements = this.querySelectorAll(`.variant-option`);
      this.optionLabelElements = Array.from(this.querySelectorAll(`.variant-option__label`));
      this.optionsSelectedValues = [];
      this.isEnableStickyATC = this.dataset.enableStickyAtc === 'true';
      this.currentVariantInfoElement = document.querySelector(`#CurrentVariantInfo__${this.sectionId}`);
      this.addtionalCurrentVariantInfoElement = document.querySelector(`#AdditionalVariantInfo__${this.sectionId}`);
      
      if (this.currentVariantInfoElement) {
        this.currentVariant = JSON.parse(this.currentVariantInfoElement.textContent);
      }
      this.sectionWrapper = document.getElementById(`shopify-section-${this.sectionId}`);
      
      if (this.currentVariant) {
        this.isOptionExist = true;
        this.isOptionAvailable = this.currentVariant.available;
      } else {
        this.isOptionExist = false;
      }
    }

    connectedCallback() {
      this.optionElements.forEach(el => {
        el.addEventListener('click', this.handleChangedOption.bind(this));
        if (this.type === 'dropdown') {
          el.addEventListener('keydown', (event) => {
            if (event.key === 'Enter' || event.key === ' ') {
              event.preventDefault();
              el.click();
            }
          })
        }
      });

      this.optionLabelElements.forEach(el => {
        el.addEventListener('keyup', el => {
          if (el.key === 'Enter' || el.key === ' ') {
            let optionInput = el.target.previousElementSibling;
            optionInput.click();
          }
        })
      });

      // --- CUSTOM LISTENER FOR YOUR TELEPORTED DRAWER ---
      window.addEventListener('variant-drawer-select', (event) => {
        if (event.detail.sectionId === this.sectionId) {
          this.handleDrawerSelection(event.detail.currentTarget);
        }
      });

      this.updateOptionSelectedValues();

      if (this.isEnableStickyATC) {
        this.__initEventSticky();
      }
    }

    // --- SYNC DRAWER SELECTION WITH THE THEME ---
    handleDrawerSelection(targetOption) {
      let position = targetOption.dataset.optionPosition;
      let newValue = targetOption.dataset.value;

      // Update visible label
      const label = this.querySelector(`.variant-option__selected-value[data-position='${position}']`);
      if (label) label.textContent = newValue;

      const btnLabel = this.querySelector(`.select-button__label[data-option-position='${position}']`);
      if (btnLabel) btnLabel.textContent = newValue;

      // Update visual checks inside the drawer
      let listOptionSamePosition = document.querySelectorAll(`[id^="VariantDrawer-${this.sectionId}"] .variant-option[data-option-position='${position}']`);
      listOptionSamePosition.forEach(optionEle => {
        const isMatch = optionEle.dataset.value === newValue;
        optionEle.classList[isMatch ? 'add' : 'remove']('selected', 'font-bold', 'bg-[rgba(var(--color-text),0.05)]', 'border-[rgba(var(--color-heading))]');
        optionEle.setAttribute("aria-selected", String(isMatch));
        
        const tick = optionEle.querySelector('.tick-container');
        if (tick) isMatch ? tick.classList.remove('hidden') : tick.classList.add('hidden');
      });

      // Trigger the standard hidden inputs to keep the theme's normal logic happy
      let internalOptions = this.querySelectorAll(`.variant-option[data-option-position='${position}']`);
      internalOptions.forEach(optionEle => {
        const isMatch = optionEle.dataset.value === newValue;
        optionEle.classList[isMatch ? 'add' : 'remove']('selected');
        optionEle.setAttribute("aria-selected", String(isMatch));
      });

      this.updateOptionSelectedValues();
      this.__renderProductInfo();
    }

    // --- EXACT NATIVE THEME LOGIC BELOW ---
    handleChangedOption(event) {
      const targetOption = event.currentTarget;
      let position = targetOption.dataset.optionPosition;
      let listOptionSamePosition = this.querySelectorAll(`.variant-option[data-option-position='${position}']`);
      listOptionSamePosition.forEach(optionEle => {
        optionEle.classList[optionEle === targetOption ? 'add' : 'remove']('selected');
        optionEle.setAttribute("aria-selected", String(optionEle === targetOption));
      });
      const selectedOptionEle = this.querySelector(`.variant-option__selected-value[data-position='${position}']`);
      if (selectedOptionEle) {
        selectedOptionEle.innerHTML = targetOption.dataset.value;
      }

      this.updateOptionSelectedValues();
      this.__renderProductInfo();
    }

    updateOptionSelectedValues() {
      this.optionsSelectedValues = [];
      this.optionElements.forEach((optionEle) => {
        const optionPosition = optionEle.dataset.optionPosition;
        const idx = Number(optionPosition) - 1;
        if (optionEle.classList.contains('selected')) {
          this.optionsSelectedValues[idx] = optionEle.dataset.optionValueId;
        }
      });

      // Check the teleported drawer as well
      const drawerOptions = document.querySelectorAll(`[id^="VariantDrawer-${this.sectionId}"] .variant-option.selected`);
      drawerOptions.forEach((optionEle) => {
        const optionPosition = optionEle.dataset.optionPosition;
        const idx = Number(optionPosition) - 1;
        this.optionsSelectedValues[idx] = optionEle.dataset.optionValueId;
      });
    }

    async __renderProductInfo() {
      const buyButtonList = this.sectionWrapper ? this.sectionWrapper.querySelectorAll(".product-info__buy-buttons-wrapper button") : [];
      buyButtonList.forEach(button => {
        button.disabled = true;
      });
      
      const url = `${this.productUrl}?option_values=${this.optionsSelectedValues.join(',')}&section_id=${this.sectionId}`;
      let productInfoHTML = CustomVariantPicker.cacheData[url];
      
      if (!productInfoHTML) {
        try {
          const response = await fetch(url);
          const text = await response.text();
          productInfoHTML = new DOMParser().parseFromString(text, "text/html");
          CustomVariantPicker.cacheData[url] = productInfoHTML;
        } catch (error) { console.error(error); return; }
      }

      const newVariantPickerEle = productInfoHTML.querySelector(`.section--${this.sectionId} custom-variant-picker.variant-picker__wrapper`) 
                               || productInfoHTML.querySelector(`.section--${this.sectionId} variant-picker.variant-picker__wrapper`);
      
      if (newVariantPickerEle) {
         this.dataset.currentVariantId = newVariantPickerEle.dataset.currentVariantId || '';
         // Grab the new media ID from Liquid, falling back to existing if empty
         this.dataset.mediaId = newVariantPickerEle.dataset.mediaId || this.dataset.mediaId;
      }
      
      const variantId = this.dataset.currentVariantId;

      if (this.isMainProduct) {
        if (variantId.length > 0){
          window.history.replaceState({}, "", `${this.productUrl}?variant=${variantId}`);
        } else {
          window.history.replaceState({}, "", `${this.productUrl}`);
        }
      }

      this.__updateCurrentVariantInfo(productInfoHTML);

      if (this.currentVariant) {
        const selectors = [
          ".product-info__price-wrapper", 
          ".product-info__identifier-wrapper", 
          ".product-info__estimate-delivery-wrapper", 
          ".product-info__quantity-wrapper", 
          ".product-info__label-wrapper", 
          ".product-info__inventory-status-wrapper", 
          ".product-info__back-in-stock-alert-wrapper", 
          ".product-template__properties" 
        ];

        const selectorsUpdateWhenAvailable = [
          '.product-info__estimate-delivery-wrapper',
          '.product-info__rating',
          '.product-info__label-wrapper',
          '.product-form__dynamic-checkout',
          `#PickupAvailability__${this.sectionId}`
        ];

        selectors.forEach(selector => {
          this.__updateElements(productInfoHTML, selector);
        });

        this.__updateTableOfInformation(productInfoHTML)

        selectorsUpdateWhenAvailable.forEach(selector => {
          const element = document.querySelector(`.section--${this.sectionId} ${selector}`);
          if (element) {
            element.classList.remove('is-unavailable');
          }
        });
      } else {
        this.__renderProductInfoWhenUnavailable();
      }

      this.__updateVariantPickerWhenChange(productInfoHTML);

      buyButtonList.forEach(button => {
        if (!button.ariaDisabled) {
          button.disabled = false;
        }
      });
      
      this.__dispatchChangeVariantEvent(productInfoHTML);

      if (this.isEnableStickyATC) {
        this.__renderStickyATC(productInfoHTML);
      }
    }

    __updateElements(productInfoHTML, selector) {
      const oldElement = document.querySelector(`.section--${this.sectionId} ${selector}`);
      const newElement = productInfoHTML.querySelector(`.section--${this.sectionId} ${selector}`);
      if (oldElement && newElement) {
        oldElement.innerHTML = newElement.innerHTML;
        if (oldElement.classList.contains('is-unavailable')) {
          oldElement.classList.remove('is-unavailable');
        }
      }
    }

    __updateTableOfInformation(productInfoHTML) {
      const selector = ".table-content__row__last";
      const oldElements = document.querySelectorAll(`.section--${this.sectionId} ${selector}`);
      const newElements = productInfoHTML.querySelectorAll(`.section--${this.sectionId} ${selector}`);
      oldElements.forEach((oldEle, index) => {
        if (newElements[index]) {
          oldEle.innerHTML = newElements[index].innerHTML;
        }
      });
    }

    __updateVariantPickerWhenChange(productInfoHTML) {
      const targetTags = `custom-variant-picker.variant-picker__wrapper`;

      this.optionElements.forEach(el => {
        const optionValueId = el.dataset.optionValueId;
        const newOptionEle = productInfoHTML.querySelector(`${targetTags} .variant-option[data-option-value-id="${optionValueId}"]`);
        if (newOptionEle) {
          el.classList[newOptionEle.classList.contains('disabled') ? 'add' : 'remove']('disabled');
          el.classList[newOptionEle.classList.contains('selected') ? 'add' : 'remove']('selected');
          el.checked = newOptionEle.classList.contains('selected');
          el.innerHTML = newOptionEle.innerHTML;
          el.dataset.selectValue = newOptionEle.dataset.selectValue;
        }
      });

      this.optionLabelElements.forEach(el => {
        const optionValueId = el.dataset.optionValueId;
        const newOptionEle = productInfoHTML.querySelector(`${targetTags} .variant-option__label[data-option-value-id="${optionValueId}"]`);
        if (newOptionEle) {
          el.classList[newOptionEle.classList.contains('disabled') ? 'add' : 'remove']('disabled');
          el.classList[newOptionEle.classList.contains('selected') ? 'add' : 'remove']('selected');
        }
      });

      const listSelectElementLabels = this.querySelectorAll(`.select-button__label.variant-option__select-button__label`);
      listSelectElementLabels.forEach(el => {
        const position = el.dataset.optionPosition;
        const newEl = productInfoHTML.querySelector(`${targetTags} .select-button__label.variant-option__select-button__label[data-option-position="${position}"]`);
        if (newEl) {
          el.innerHTML = newEl.innerHTML.trim();
        }
      });
    }

    __renderStickyATC (productInfoHTML) {
      const selectors = [
        `#StickyAddToCart__Image__${this.sectionId}`,
        `#StickyAddToCart__Variant__${this.sectionId}`,
        `#StickyAddToCart__Price__${this.sectionId}`,
        `.sticky-add-to-cart__form`
      ];

      selectors.forEach(selector => {
        this.__updateElements(productInfoHTML, selector);
      });
    }

    __initEventSticky() {
      document.addEventListener(`${STICKY_ATC_EVENT.optionChange}-${this.sectionId}`, (event) => {
        if (event.detail.optionsSelectedValues) {
          this.optionsSelectedValues = event.detail.optionsSelectedValues;
          this.__renderProductInfo();
        }
      });
    }

    __updateCurrentVariantInfo(productInfoHTML) {
      const newCurrentVariantInfoElement = productInfoHTML.querySelector(`#CurrentVariantInfo__${this.sectionId}`);
      if (newCurrentVariantInfoElement) {
        if(this.currentVariantInfoElement) this.currentVariantInfoElement.textContent = newCurrentVariantInfoElement.textContent;
        this.currentVariant = JSON.parse(newCurrentVariantInfoElement.textContent);
      }

      const newAdditionalCurrentVariantInfoElement = productInfoHTML.querySelector(`#AdditionalVariantInfo__${this.sectionId}`);
      if (newAdditionalCurrentVariantInfoElement) {
        if(this.addtionalCurrentVariantInfoElement) this.addtionalCurrentVariantInfoElement.textContent = newAdditionalCurrentVariantInfoElement.textContent;
      }

      if (this.currentVariant) {
        this.isOptionExist = true;
        this.isOptionAvailable = this.currentVariant.available;
      } else {
        this.isOptionExist = false;
      }
    }

    __renderProductInfoWhenUnavailable() {
      const selectors = [
        ".product-info__price-wrapper", 
        ".product-info__identifier-wrapper", 
        ".product-info__estimate-delivery-wrapper", 
        ".product-info__label-wrapper", 
        ".product-info__inventory-status-wrapper", 
        ".product-info__rating", 
        `#PickupAvailability__${this.sectionId}`
      ];

      selectors.forEach(selector => {
        const element = document.querySelector(`.section--${this.sectionId} ${selector}`);
        if (element) {
          element.classList.add('is-unavailable');
        }
      });
    }

    __dispatchChangeVariantEvent(updatedHTML) {
      if (typeof PRODUCT_EVENT !== 'undefined') {
        document.dispatchEvent(
          new CustomEvent(`${PRODUCT_EVENT.updatedVariant}${this.sectionId}`, {
            bubbles: true,
            detail: {
              productId: this.productId,
              currentVariant: this.currentVariant,
              sectionId: this.sectionId,
              isOptionAvailable: this.isOptionAvailable,
              isOptionExist: this.isOptionExist,
              // Powered by the robust Liquid fallback tag now!
              previewMediaId: this.dataset.mediaId, 
              optionsSelectedValues: this.optionsSelectedValues,
              updatedHTML: updatedHTML
            },
          })
        );
      }
    }
  }

  if (!customElements.get('custom-variant-picker')) {
    customElements.define('custom-variant-picker', CustomVariantPicker);
  }
}